// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface QuickOrderHeaderStyles {}

export const quickOrderHeaderStyles: QuickOrderHeaderStyles = {};

const styles = quickOrderHeaderStyles;

const QuickOrderHeader: FC<Props> = ({ id, pageTitle }: Props) => {
    return (
        <OrderHeader title={pageTitle}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(QuickOrderHeader),
    definition: {
        group: "Quick Order",
        displayName: "Header",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
